<!--抄表系统首页 meterHome-->
<template>
  <div class="custom-scrollbar" style="padding: 10px;height: auto;padding-bottom: 60px;box-sizing: border-box;">
    <div class="flexBetween" style="height: calc(50% - 5px);">
      <div class="meterHomeLeft">
        <div class="areaContainer">
          <p class="areaTitle">小区概况</p>
          <div class="flexAround areaContentHeight" style="align-items: center;">

            <div class="houseInfoLi">
              <div class="iconMeterHome">
                <img
                  :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/overview/20230516110046.png')"
                  alt="" />
              </div>
              <p><span class="warncolor">{{countInfo.onlineMeter}}</span><span>{{countInfo.allMeter}}</span></p>
              <p>电能表上线数</p>
            </div>

            <div class="houseInfoLi">
              <div class="iconMeterHome">
                <img
                  :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/overview/20230516110035.png')"
                  alt="" />
              </div>
              <p><span class="warncolor">{{countInfo.onlineWater}}</span><span>{{countInfo.allWaterMeter}}</span></p>
              <p>水表上线数</p>
            </div>

            <div class="houseInfoLi">
              <div class="iconMeterHome">
                <img :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/overview/unPay.png')"
                  alt="" />
              </div>
              <p><span class="warncolor">{{countInfo.arrearsMeter}}</span><span>{{countInfo.allMeter}}</span></p>
              <p>欠费未缴纳数</p>
            </div>
            <div class="houseInfoLi">
              <div class="iconMeterHome">
                <img :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/overview/customer.png')"
                  alt="" />
              </div>
              <p><span>{{countInfo.owner}}</span></p>
              <p>客户数</p>
            </div>
            <div class="houseInfoLi">
              <div class="iconMeterHome">
                <img :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/overview/warn.png')"
                  alt="" />
              </div>
              <p><span class="warncolor">{{countInfo.unConfirmGj}}</span><span>{{countInfo.gj}}</span></p>
              <p>未确认告警数</p>
            </div>
          </div>
        </div>
        <div class="areaContainer">
          <p class="areaTitle">实时缴费信息</p>
          <div v-show="payRecords.total <= 0" class="flexCenter" style="height: calc(100% - 48px);">
            <p class="notAvailableMessage">暂无缴费信息</p>
          </div>
          <ul v-show="payRecords.total > 0" class="custom-scrollbar" style="height: calc(100% - 48px);">
            <li class="messageLi" v-for="item in payRecords.dataList">
              <span class="messageAlert">{{getPayTime(item)}}</span>{{item.createName}} 通过<span
                class="payType">{{getPayType(item)}}</span>缴纳<span>{{getPayNum(item)}}</span>元
            </li>
          </ul>
        </div>
      </div>
      <div class="meterHomeCenter">
        <div class="areaContainer">
          <p class="areaTitle">缴费设备比率</p>
          <vchart class="pieChartHeight" ref='vchartPiePaymentRate' style="    height: calc(71% - 48px) !important;">
          </vchart>
          <div class="payTypeMoney">
            <div class="flexBetween">

              <div class="paySum"><span>微信</span><span>{{moneyRecord.Recharge_WeixinPay / 100}}元</span></div>
              <!-- <div class="paySum"><span>银行卡</span><span>{{countPayRecord.Recharge_UnionPay / 100}}元</span></div>
            </div>
            <div class="flexBetween">
              <div class="paySum"><span>支付宝</span><span>{{countPayRecord.Recharge_AliPay / 100}}元</span></div> -->
              <div class="paySum"><span>现金支付</span><span>{{moneyRecord.Recharge_CashPay / 100}}元</span></div>
            </div>
          </div>
        </div>
      </div>
      <div class="meterHomeRight">
        <div class="areaContainer">
          <p class="areaTitle">预警概况</p>
          <vchart class="pieChartHeight" ref='vchartPieEarlyWarning'></vchart>
          <p class="areaTitle">实时预警</p>
          <div v-show="unitWarnEvent.total <= 0" class="flexCenter warnContentHeight">
            <p class="notAvailableMessage">暂无预警信息</p>
          </div>
          <ul v-show="unitWarnEvent.total > 0" class="custom-scrollbar warnContentHeight">
            <li class="messageLi" v-for="(event, index) in unitWarnEvent.data" :key="'warn'+index">
              <span class="messageAlert">{{event.typeName}}</span>{{event.deviceName}}&nbsp;{{new
              Date(event.time).formatByTime()}}&nbsp;{{event.description}}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="areaContainer" style="margin-top: 10px;height:55%;">
      <p class="areaTitle">
        <el-select v-model="value" placeholder="请选择" size="mini" style="margin-right:10px" @change="valueFn">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select> {{value==2?'小区用电分析（单位：KWH）':'小区用水分析（单位：m³）'}}
      </p>
      <div class="custom-scrollbar" style="height: 100px;">
        <powerValueViewTwo ref="powerValueViewTwo" :state="value"></powerValueViewTwo>
      </div>
      <vchart style="height: calc(100% - 170px);" ref='vchartBar'></vchart>
    </div>
  </div>
</template>

<script>
  import vchart from '@/components/module/chart/vchart.vue'
  import powerValueViewTwo from './PowerValueViewTwo.vue'
  import meterReadingStore from './meterReadingStore.js'
  import request from "@/api/http.js";
  export default {
    components: {
      vchart,
      powerValueViewTwo
    },
    props: {},
    data () {
      return {
        options: [{
          value: '1',
          label: '水'
        },{
          value: '2',
          label: '电'
        }],
        value: '2',
        barOption: {
          toolbox: {
            right: 25,
            show: true,
            iconStyle: {
              borderColor: "#94d6da"

            },
            feature: {
              magicType: {type: ['line','bar']},
              restore: {},
              saveAsImage: {}
            }
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          xAxis: [{
            type: 'category',
            axisLabel: {
              textStyle: {
                color: '#000'
              }
            },
            axisLine: {
              show: false

            },
            data: ['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19',
              '20','21','22','23','24','25','26','27','28','29','30','31'
            ],
          }],
          yAxis: [{
            axisLabel: {
              textStyle: {
                color: '#000'
              }
            },
            axisLine: {
              show: false

            },
            type: 'value',
          }],
          legend: {
            top: '6px',
            textStyle: {
              color: '#000'
            },
            show: true,
          },
          grid: {
            height: '70%',

            left: '2%',
            right: '1%',
            bottom: '5%',
            containLabel: true
          },
          backgroundColor: '',
          series: [
          ]
        },
        moneyRecord: {},//缴费设备比例
        optionsPie: {
          color: ['#F2637B','#3AA1FF','#36CBCB','#4ECB73','#FBD437'],
          tooltip: {
            trigger: 'item',
            formatter: "{a}</br>{b} : {c} ({d}%)"
          },
          legend: {
            type: 'scroll',
            icon: 'circle',
            itemHeight: 8,
            itemWidth: 8,
            orient: 'horizontal',
            bottom: 0,
          },
          series: []
        },
        optionsBar: {
          toolbox: {
            show: true,
            feature: {
              magicType: {
                type: [
                  "line",
                  "bar"
                ]
              }
            },
            right: "5%",
            top: 10
          },
          tooltip: {
            trigger: "axis",
            confine: true,
            axisPointer: {
              animation: true
            }
          },
          xAxis: {
            type: "category",
            data: ['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19',
              '20','21','22','23','24','25','26','27','28','29','30','31'
            ]
          },
          yAxis: {
            type: "value",
            boundaryGap: [
              0,
              "100%"
            ],
            splitLine: {
              show: true
            }
          },
          dataZoom: [
            {
              type: "inside",
              start: 0,
              end: 100
            }
          ],
          grid: {
            left: 10,
            right: 10,
            bottom: 25,
            top: 10,
            containLabel: true
          },
          legend: {
            type: "scroll",
            bottom: 0,
            tooltip: {
              show: true
            },
            selected: {

            }
          },
          series: []
        },
      }
    },
    mounted () {
      this.getList();

      this.barOption.series=[{
        name: '电量',
        type: 'bar',
        data: [],
        itemStyle: {
          color: '#1491ff',
        }
      },{
        name: '电费',
        type: 'bar',
        data: [],
        itemStyle: {
          color: '#fbd549',
        }
      }]

      this.$refs.vchartBar.setData(this.barOption)
      this.reloadBarChart();// 电量电费数据

      this.$refs.vchartPieEarlyWarning.setData(this.optionsPie,true)
      // this.reloadBarChart(this.powerDataList)
      meterReadingStore.commit("setNowUser",this.nowUser)
      meterReadingStore.commit("setNowUnit",this.nowUnit)
      meterReadingStore.commit('setAllEventTypes',this.allEventTypes)
      meterReadingStore.commit('getDeviceCount',this.nowUnit.id)
      addNewTask('getMeterHomeEvents',30000,30000,-1,() => {
        if(!isempty(meterReadingStore.state.deviceNos)) {
          meterReadingStore.commit('getUnitAllEvent',meterReadingStore.state.deviceNos.join(','))
          meterReadingStore.commit('getCountAllEvents',meterReadingStore.state.deviceNos.join(','))
        }
      })
    },
    beforeDestroy () {
      removeTask('getMeterHomeEvents')
    },
    computed: {
      nowUser () {
        return this.$store.userStore.state.nowUserInfo
      },
      nowUnit () {
        return this.$store.unitStore.state.nowUnit
      },
      countInfo () {
        return meterReadingStore.state.countInfo
      },
      allEventTypes () {
        return this.$store.eventStore.getters.searchAllEventTypes
      },
      piePaymentRate () {
        return meterReadingStore.getters.getPiePaymentRate
      },
      pieEarlyWarning () {
        return meterReadingStore.getters.getPieEarlyWarning
      },
      countPayRecord () {
        return meterReadingStore.getters.getCountPayRecord
      },
      payRecords () {
        return meterReadingStore.state.payRecords
      },
      unitWarnEvent () {
        return meterReadingStore.state.unitAllEvent
      },
      getPayTime () {
        return bill => {
          return new Date(bill.createTime).formatByTime()
        }
      },
      getPayNum () {
        return bill => {
          return bill.amount/100
        }
      },
      getPayType () {
        return bill => {
          switch(bill.detailType) {
            case 'Recharge_AliPay':
              return '支付宝'
            case 'Recharge_CashPay':
              return '现金支付'
            case 'Recharge_UnionPay':
              return '银行卡'
            case 'Recharge_WeixinPay':
              return '微信'
          }
        }
      },
      powerDataList () {
        return meterReadingStore.getters.getPowerDataList
      },
    },
    watch: {
      piePaymentRate (nv,ov) {
        this.getList()
        // this.$refs.vchartPiePaymentRate.setData(nv)
      },
      pieEarlyWarning (nv,ov) {
        this.$refs.vchartPieEarlyWarning.setData(nv)
      },
      nowUser (nv,ov) {
        meterReadingStore.commit("setNowUser",nv)
      },
      nowUnit (nv,ov) {
        meterReadingStore.commit("setNowUnit",nv)
      },
      allEventTypes (nv,ov) {
        meterReadingStore.commit('setAllEventTypes',nv)
      },
      powerDataList (nv,ov) {
        this.reloadBarChart(nv)
      }
    },
    methods: {
      getList () {
        var params={
          targetIds: this.nowUnit.id,
          type: 'MeterReading',
          beginTime: new Date(new Date().getFullYear()+'-01-01').getTime(),
          endTime: new Date().getTime()
        }

        // Get请求
        request({url: "/moneyRecord/countNewPayRecord.do",method: "get",params}).then(res => {
          this.moneyRecord=res.data;


          var nv={
            "series": [{
              "name": "设备缴费比率",
              "type": "pie",
              "radius": "60%",
              "minAngle": 15,
              "center": ["50%","45%"],
              "data": [{
                "name": "现金支付",
                "value": this.moneyRecord.Recharge_CashPay/100,
                "labelLine": {
                  "length": 10,
                  "length2": 10
                }
              },{
                "name": "微信",
                "value": this.moneyRecord.Recharge_WeixinPay/100,
                "labelLine": {
                  "length": 10,
                  "length2": 10
                }
              }],
              "itemStyle": {
                "emphasis": {
                  "shadowBlur": 10,
                  "shadowOffsetX": 0,
                  "shadowColor": "rgba(0, 0, 0, 0.5)"
                }
              }
            }]
          }

          this.$refs.vchartPiePaymentRate.setData(nv)
        })
      },
      valueFn () {
        setTimeout(() => {
          this.$refs.powerValueViewTwo.getPowerValue(this.$store.unitStore.getters.getNowUnit.id);
          this.reloadBarChart()
        },200);
      },
      // 水量水费数据
      reloadBarChart2 () {
        var params={
          timeStamp: new Date().getTime(),
          unitId: this.$store.unitStore.getters.getNowUnit.id,
        }
        request({url: "/cost/findWaterCostFromMonth",method: "get",params}).then(res => {
          console.log(res,'水量水费数据');
          var a=[];
          var b=[];
          if(res.code==200) {
            for(const key in res.data) {
              a.push(res.data[key]['总电量'])
              b.push(res.data[key]['总电费'])
            }

            this.barOption.series=[{
              name: '水量',
              type: 'bar',
              data: a,
              itemStyle: {
                color: '#1491ff',
              }
            },{
              name: '水费',
              type: 'bar',
              data: b,
              itemStyle: {
                color: '#fbd549',
              }
            }]
            this.$refs.vchartBar.setData(this.barOption)
          }
        })
      },
      // 电量电费数据
      reloadBarChart () {
        if(this.value==1) {//判断水
          this.reloadBarChart2();
          return
        }
        var params={
          timeStamp: new Date().getTime(),
          unitId: this.$store.unitStore.getters.getNowUnit.id,
        }
        // /cost/findCostFromMonth 旧
        // /cost/findSingleCostFromMonth 新
        request({url: "/cost/findSingleCostFromMonth",method: "get",params}).then(res => {
          var a=[];
          var b=[];
          if(res.code==200) {
            for(const key in res.data) {
              a.push(res.data[key]['总电量'])
              b.push(res.data[key]['总电费'])
            }

            this.barOption.series=[{
              name: '电量',
              type: 'bar',
              data: a,
              itemStyle: {
                color: '#1491ff',
              }
            },{
              name: '电费',
              type: 'bar',
              data: b,
              itemStyle: {
                color: '#fbd549',
              }
            }]
            console.log(this.barOption,'11');
            this.$refs.vchartBar.setData(this.barOption)
          }
        })
      },
      initFormatter () {
        this.optionsBar.tooltip.formatter=(params,ticket,callback) => {
          if(params[0].data==undefined) {
            return ""
          }
          var h=params[0].data[0]
          var label=h+"日</br>"
          params.forEach(item => {
            var values
            if(isnull(item.data[1])) {
              values="无采集数据"
            } else {
              values=cutDigital(item.data[1])
            }
            label+=item.seriesName+" : "+values+" (kW·h)</br>"
          })
          return label
        }
      },
      // reloadBarChart (list) {
      //   var money=[]
      //   var power=[]
      //   if(!isempty(list)) {
      //     Object.keys(list).forEach(key => {
      //       var pw=list[key]['总电量']
      //       var my=list[key]['总电费']
      //       if(this.$historyTools.isNull(my)) {
      //         my=undefined
      //       }
      //       if(this.$historyTools.isNull(pw)) {
      //         pw=undefined
      //       }
      //       money.push(my)
      //       power.push(pw)
      //     })
      //   }
      //   this.optionsBar.series=[{
      //     name: '电量',
      //     type: 'bar',
      //     data: power
      //   },{
      //     name: '电费',
      //     type: 'bar',
      //     data: money
      //   }]
      //   // this.$refs.vchartBar.setData(this.optionsBar)
      // },
    }
  }
</script>

<style scoped>
  .meterHomeLeft {
    width: calc(40% - 5px);
    height: 100%;
  }

  .meterHomeCenter {
    width: calc(30% - 7.5px);
    height: 100%;
  }

  .meterHomeRight {
    width: calc(30% - 7.5px);
    height: 100%;
  }

  .meterHomeLeft>.areaContainer:first-child {
    height: calc(60% - 10px);
  }

  .meterHomeLeft>.areaContainer:last-child {
    height: 40%;
    margin-top: 10px;
  }

  .meterHomeCenter>.areaContainer,
  .meterHomeRight>.areaContainer {
    height: 100%;
  }

  .areaContainer {
    padding: 0 10px 10px 10px;
    background: #FFFFFF;
    box-sizing: border-box;
  }

  .areaTitle {
    font-size: .16rem;
    font-weight: bold;
    line-height: 48px;
  }

  .areaContentHeight {
    height: calc(100% - 48px);
  }

  .pieChartHeight {
    height: calc(60% - 48px) !important;
  }

  .houseInfoLi {
    text-align: center;
  }

  .houseInfoLi>p {
    margin-bottom: 8px;
  }

  .houseInfoLi>p:nth-of-type(1)>span {
    font-weight: bold;
    padding: 0 8px;
  }

  .houseInfoLi>p:nth-of-type(1)>span:nth-of-type(2) {
    border-left: solid 2px #000000;
  }

  .warncolor {
    color: #FF9900;
  }

  .iconMeterHome {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 90px;
    height: 90px;
    border-radius: 50%;
    margin-bottom: 20px;
  }

  .houseInfoLi:nth-child(1)>.iconMeterHome {
    background: #409EFF;
  }

  .houseInfoLi:nth-child(2)>.iconMeterHome {
    background: #67C23A;
  }

  .houseInfoLi:nth-child(3)>.iconMeterHome {
    background: #FF9900;
  }

  .houseInfoLi:nth-child(4)>.iconMeterHome {
    background: #339999;
  }

  .houseInfoLi:nth-child(5)>.iconMeterHome {
    background: #339999;
  }

  .payTypeMoney {
    height: calc(40% - 20px);
    border-top: solid 1px #E4E4E4;
    display: flex;
    flex-wrap: wrap;
    align-content: space-around;
    margin-top: 20px;
  }

  .payTypeMoney>div {
    width: 100%;
  }

  .warnContentHeight {
    height: calc(40% - 48px);
  }

  .messageLi {
    padding: 4px 8px;
    border: solid 1px #F2F2F2;
    margin-bottom: 8px;
  }

  .messageLi:last-child {
    margin-bottom: 0;
  }

  .messageAlert {
    display: inline-block;
    border: solid 1px #FF9900;
    border-radius: 4px;
    padding: 0 4px;
    font-size: .12rem;
    color: #FF9900;
    margin-right: 2px;
  }

  .payType {
    color: #409EFF;
  }

  .paySum {
    display: inline-block;
    border: solid 1px #F2F2F2;
    width: calc(50% - 20px);
    text-align: center;
  }

  .paySum>span {
    line-height: 30px;
    display: inline-block;
  }

  .paySum>span:first-child {
    margin-right: 20px;
  }

  .electricAnalyzeLi {
    display: inline-block;
    width: 175px;
    margin-right: 42px;
    border: solid 1px #E4E4E4;
    text-align: center;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    overflow: hidden;
  }

  .electricAnalyzeLi>p:first-child {
    background: #409EFF;
    line-height: 36px;
    color: #FFFFFF;
  }

  .electricAnalyzeLi>p:last-child {
    line-height: 42px;
  }

  .electricAnalyzeLi:last-child {
    margin-right: 0;
  }

  .electricAnalyzeSafe {
    background: #67C23A !important;
  }

  .electricAnalyzeDanger {
    background: #FF9900 !important;
  }

  .notAvailableMessage {
    border: solid 1px #E4E4E4;
    padding: 4px 50px;
    color: #CACACA;
  }

  @media screen and (max-width: 1600px) {
    .houseInfoLi {
      margin-top: 10px;
    }

    .iconMeterHome {
      width: 60px;
      height: 60px;
      margin-bottom: 10px;
    }

    .iconMeterHome>img {
      transform: scale(0.6);
    }

    .payTypeMoney {
      height: calc(35% - 10px);
      margin-top: 10px;
    }
  }

  @media screen and (max-width: 1400px) {
    .areaTitle {
      font-size: .14rem;
      line-height: 30px;
    }

    .areaContentHeight {
      height: calc(100% - 30px);
    }

    .pieChartHeight {
      height: calc(65% - 30px) !important;
    }

    .warnContentHeight {
      height: calc(35% - 30px);
    }

    .houseInfoLi {
      margin-top: 10px;
    }

    .iconMeterHome {
      width: 40px;
      margin-bottom: 10px;
      height: 40px;
    }

    .iconMeterHome>img {
      transform: scale(0.4);
    }

    .payTypeMoney {
      height: calc(35% - 10px);
      margin-top: 10px;
    }
  }
</style>